import React from "react";
import { Alert, List, QRCode, Typography, Image } from 'antd';
import Moment from 'react-moment';
import Common from "./includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OrderReceipt = function OrderReceipt(_ref) {
  var createdValues = _ref.createdValues,
    createdBill = _ref.createdBill,
    _ref$isPdaActive = _ref.isPdaActive,
    isPdaActive = _ref$isPdaActive === void 0 ? 0 : _ref$isPdaActive,
    _ref$receipAmount = _ref.receipAmount,
    receipAmount = _ref$receipAmount === void 0 ? 0 : _ref$receipAmount,
    _ref$rdata = _ref.rdata,
    rdata = _ref$rdata === void 0 ? [] : _ref$rdata,
    _ref$currentCompany = _ref.currentCompany,
    currentCompany = _ref$currentCompany === void 0 ? null : _ref$currentCompany,
    _ref$discount = _ref.discount,
    discount = _ref$discount === void 0 ? 0 : _ref$discount;
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: createdValues && /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '130px',
          textAlign: 'center !important'
        },
        children: Common.account == 'undefined' && Common.account.logo == null ? /*#__PURE__*/_jsx(Image, {
          preview: false,
          width: "100%",
          src: "/drawables/cl.png"
        }) : /*#__PURE__*/_jsx(Image, {
          preview: false,
          width: "100%",
          src: Common.baseUrl + Common.account.logo
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("b", {
          children: "Date:"
        }), " ", /*#__PURE__*/_jsx(Moment, {
          format: "DD/MM/YYYY H:m"
        })]
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["ID PATIENT : ", createdValues.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", createdValues.firstname + " " + createdValues.lastname]
      }), /*#__PURE__*/_jsx(List, {
        header: /*#__PURE__*/_jsx("div", {
          children: "Actes / Produit(s)"
        }),
        footer: /*#__PURE__*/_jsx("b", {
          children: "TOTAL (GNF) " + receipAmount.toLocaleString('Fr')
        }),
        bordered: true,
        dataSource: rdata,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            children: /*#__PURE__*/_jsx(Typography.Text, {
              mark: true,
              children: item
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
        children: ["REMISE ", discount, "% ", isPdaActive == 1 && /*#__PURE__*/_jsxs("span", {
          style: {
            color: "#8F4F31"
          },
          children: ["(*Paiement diff\xE9r\xE9 autoris\xE9. Reste \xE0 payer : ", (createdBill.total_amount - createdBill.paid_amount).toLocaleString("Fr"), " GNF)"]
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
        style: {
          textAlign: "center"
        },
        children: createdBill && /*#__PURE__*/_jsx(QRCode, {
          type: "svg",
          value: "https://cliniqueadmin.com/#/checkreceipt/" + createdBill.id.toString(),
          size: 65
        })
      }), /*#__PURE__*/_jsx("br", {}), currentCompany != null && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        banner: true,
        message: "Prise en charge de " + currentCompany.rate.toString() + "% par " + currentCompany.label
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), Common.account != 'undefined' && Common.account != null && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsxs("b", {
          children: ["Adresse: ", Common.account.address, " - Tel: ", Common.account.mobile]
        })
      })]
    })
  });
};
export default OrderReceipt;